<template>
    <div class="show-map-dialog">
      <el-dialog :visible.sync="showMapFlag" :closeOnClickModal="true" :showClose="true" :width="'666px'"
                 :destroyOnClose="true" :appendToBody="true" :customClass="''" :before-close="hideMap">
        <div slot="title"><i class="el-icon-location-outline"></i><span style="padding-left: 5px;color: #666666">{{addressTitle}}</span></div>
        <div class="map">
          <el-amap vid="map" :plugin="plugin" :center="targetPoint" class="map-content">
            <el-amap-marker vid="component-marker" :position="targetPoint" :events="markerEvents"></el-amap-marker>
            <el-amap-info-window
              :position="targetPoint"
              :content="addressTitle"
              :visible="showAddressTitle"
              :showShadow="true"
              :events="windowEvents"
              :offset="[0, -30]">
            </el-amap-info-window>
          </el-amap>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'ShowMap',
  props: ['showMapFlag', 'positionObj'],
  data () {
    return {
      showAddressTitle: true,
      targetPoint: [114.068801, 22.659153],
      addressTitle: '',
      markerEvents: null,
      windowEvents: null,
      plugin: [{
        pName: 'ToolBar',
        events: {
          init (instance) {
            // console.log(instance)
          }
        }
      }, {
        pName: 'Scale',
        events: {
          init (instance) {
            // console.log(instance)
          }
        }
      }]
    }
  },
  methods: {
    hideMap (done) {
      this.$emit('hideMap')
      // done()
    }
  },
  mounted () {
    let _ = this
    this.markerEvents = {
      click () {
        _.showAddressTitle = true
        /* _.$nextTick(() => {
          _.showAddressTitle = true
        }) */
      }
    }
    this.windowEvents = {
      close () {
        _.showAddressTitle = false
      }
    }

    this.targetPoint = this.positionObj.location.split(',')
    this.addressTitle = this.positionObj.positionAddress
  }
}
</script>

<style scoped>
  /deep/ .el-dialog__body {
    padding: 0;
  }
  .map-content {
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShowMap/ShowMap.vue